import jwt_decode from 'jwt-decode'

/**
 * Decodifica el payload de un JWT en cliente. Solo lee el payload —nunca verifica
 * la firma en el backend.
 *
 * @param {string} jwt - El token a decodificar.
 * @returns {object|null} El payload decodificado, o null si el token es inválido.
 */
export const decodeToken = (jwt) => {
  try {
    return jwt_decode(jwt)
  } catch {
    return null
  }
}
